import React, { useState } from "react";
import {
  View,
  Image,
  TouchableOpacity,
  StyleSheet,
  Linking,
  Platform,
} from "react-native";
import Feather from "@expo/vector-icons/Feather";
import CommonModal from "./CommonModal";

const ImagePreviewGrid = ({ images = [], onDelete }) => {
  const handleView = (uri) => {
    if (Platform.OS === "web") {
      window.open(uri, "_blank");
    } else {
      Linking.openURL(uri);
    }
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const confirmDeleteImage = (index) => {
    onDelete(index)
    setShowDeleteModal(false);
  };
 
  return (
    <View style={styles.previewContainer}>
      {images.map((img, index) => (
        <View key={index} style={styles.imageCard}>
          <Image source={{ uri: img }} style={styles.image} />

          <View style={styles.overlay}>
            {/* View Button */}
            <TouchableOpacity
              style={styles.iconButton}
              onPress={() => handleView(img)}
            >
              <Feather name="eye" size={16} color="#fff" />
            </TouchableOpacity>

            {/* Delete Button */}
            <TouchableOpacity
              style={[styles.iconButton, styles.deleteButton]}
              onPress={() => {
                setDeleteIndex(index)
                setShowDeleteModal(true)}}
            >
              <Feather name="trash-2" size={16} color="#fff" />
            </TouchableOpacity>
          </View>
        </View>
      ))}
      <CommonModal
  visible={showDeleteModal}
  heading="Are you sure?"
  subheading="Are you sure, you want to delete this image?"
  yesText="Yes, delete"
  noText="Cancel"
  onNo={() => setShowDeleteModal(false)}
  onYes={()=>confirmDeleteImage(deleteIndex)}
/>
    </View>
  );
};

export default ImagePreviewGrid;

const styles = StyleSheet.create({
  previewContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 15,
    marginTop: 15,
  },

  imageCard: {
    width: 120,
    height: 120,
    borderRadius: 16,
    overflow: "hidden",
    backgroundColor: "#f5f5f5",
    position: "relative",

    shadowColor: "#000",
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 5,
  },

  image: {
    width: "100%",
    height: "100%",
  },

  overlay: {
    position: "absolute",
    top: 8,
    right: 8,
    flexDirection: "row",
    gap: 6,
  },

  iconButton: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: "rgba(0,0,0,0.65)",
    justifyContent: "center",
    alignItems: "center",
  },

  deleteButton: {
    backgroundColor: "#ff4d4f",
  },
});
